import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  constructor(private dataService: DataService) { }

  getSubscriptions(page: number, size: number) {
    return this.dataService.getSubscriptions(page, size);
  }

  getSubscription(code: string) {
    return this.dataService.getSubscription(code);
  }
}
